import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import CryptoJS from "crypto-js";

const LogoutHandler = () => {
  const location = useLocation();
  const accessToken = secureLocalStorage.getItem("accessToken");
  const pathName = location?.pathname?.split("/");

  const empIDFromURL = pathName[2];

  // Function to decrypt the data
  const decrypt = (encryptedData, encryptionKey) => {
    try {
      // Decode the base64 encrypted data into a byte array
      const combined = CryptoJS.enc.Base64.parse(encryptedData);

      // Extract salt (first 16 bytes)
      const salt = CryptoJS.lib.WordArray.create(combined.words.slice(0, 4));

      // Extract IV (next 16 bytes)
      const iv = CryptoJS.lib.WordArray.create(combined.words.slice(4, 8));

      // The remaining part is the encrypted content
      const encrypted = CryptoJS.lib.WordArray.create(combined.words.slice(8));

      // Derive the secret key using PBKDF2 with the provided salt
      const secretKey = deriveKey(encryptionKey, salt);

      // Decrypt the data using AES with the derived key and IV
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encrypted },
        secretKey,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7, // Ensure proper padding
        }
      );

      // Return the decrypted data as a UTF-8 string
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

      // Check if decryption is successful
      if (!decryptedText) {
        throw new Error("Decrypted data is empty or invalid UTF-8.");
      }

      return decryptedText;
    } catch (error) {
      console.error("Decryption error:", error.message);
      return null;
    }
  };
  const deriveKey = (password, salt) => {
    return CryptoJS.PBKDF2(password, salt, {
      keySize: 256 / 32,
      iterations: 65536,
    });
  };
  useEffect(() => {
    const logoutUser = async () => {
      try {
        const empID = isNaN(empIDFromURL)
          ? empIDFromURL
          : parseInt(empIDFromURL, 10);

        const logoutReq = pathName[1] === "logout" ? true : false;

        if (logoutReq) {
          const response = await axios.post(
            `${process.env.REACT_APP_BACKEND}/${pathName[1]}`,
            { empID: empID, encryptedToken: accessToken },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          if (response.status === 200 && response?.data?.dataVT !== undefined) {
            const decryptedData = decrypt(
              response?.data?.dataVT,
              process.env.REACT_APP_SSO_ENCRYPTION_KEY
            );
            const decryptedObject = JSON.parse(decryptedData);

            if (decryptedObject && decryptedObject?.empID === empID) {
              secureLocalStorage.clear();
              localStorage.setItem("logout", Date.now().toString()); // Sync logout across tabs
            }

            // Send a JSON response
            const respose = {
              status: "success",
              message: "Logged out successfully",
            };

            // Display JSON response in the browser
            document.body.innerText = JSON.stringify(respose);
          }
        } else {
          console.error("Unexpected response status:");
        }
      } catch (error) {
        console.error("Error during logout:", error);
      }
    };

    logoutUser();
  }, []);

  return null; // Prevents rendering any UI to avoid 404 component display
};

export default LogoutHandler;
